export default "__VITE_ASSET__C5Ba$gq___"